module.exports = __webpack_public_path__ + "static/media/iconCommitBike.066d7a4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconCommitBike.svg
// module id = 943
// module chunks = 0